<template>
    <div>
        <Loader v-if="isLoading"></Loader>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header">
                    <h3 class="fw-bold mb-3">Clientes</h3>
                    <ul class="breadcrumbs mb-3">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de Clientes</a>
                        </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click="EditNew()">Incluir Novo</a> </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <v-tabs v-model="tab" color="deep-purple-accent-4" bg-color="#dadcdf">
                                    <v-tab value="dados" class="tabinfo"
                                        style="font-size: 13px;text-transform: none !important;">Dados Cliente</v-tab>
                                    <div v-if="Cliente.cliId != 0">
                                        <v-tab value="endereco" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">Endereço</v-tab>
                                    </div>
                                    <div v-if="Cliente.cliId != 0 && Cliente.tpdId == 1 && isCheckedConjuge">
                                        <v-tab value="conjuge" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">Conjuge</v-tab>
                                    </div>
                                    <div v-if="Cliente.cliId != 0 && isCheckedCorresponsvel">
                                        <v-tab value="corresponsavel" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">Corresponsável
                                            1</v-tab>
                                    </div>
                                    <div v-if="Cliente.cliId != 0 && isCheckedCorresponsvel">
                                        <v-tab value="corresponsavel2" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">Corresponsável
                                            2</v-tab>
                                    </div>
                                    <div v-if="Cliente.cliId != 0">
                                        <v-tab value="docs" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">Documentos</v-tab>
                                    </div>
                                    <div v-if="Cliente.cliId != 0 && User.tpeid != 3 && ListaConsultas.lenght > 0">
                                        <v-tab value="consultas" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">Consultas
                                            Crédito</v-tab>
                                    </div>

                                </v-tabs>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Cliente.cliId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <select v-model="Cliente.garId"
                                                                class="form-select form-control"
                                                                @change="BuscaImobiliarias()">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListGarantidorasGeral"
                                                                    :key="optionTipo.garId" :value="optionTipo.garId">{{
                                                                    optionTipo.garNomeEmpresa }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4"
                                                        v-if="User.garid == 0 || User.tpeid == 1">
                                                        <div class="form-group">
                                                            <label>Imobiliaria</label>
                                                            <select v-model="Cliente.imoId"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListImobiliariasGeral"
                                                                    :key="optionTipo.imoId" :value="optionTipo.imoId">{{
                                                                    optionTipo.imoNomeEmpresa }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Tipo Pessoa</label>
                                                            <select v-model="Cliente.tpdId"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in TiposDocumentos"
                                                                    :key="optionTipo.tpdId" :value="optionTipo.tpdId">{{
                                                                    optionTipo.tpdNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Nº {{ Cliente.tpdId == 1 ? 'CPF' : 'CNPJ' }}</label>
                                                            <input v-model="Cliente.cliDocumento" type="text"
                                                                v-mask="documentoMask" class="form-control"
                                                                @input="NormalizaDocumentoPessoa(Cliente, 'cliDocumento')"
                                                                :placeholder="Cliente.tpdId == 1 ? 'CPF' : 'CNPJ'" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome</label>
                                                            <input v-model="Cliente.cliNomeEmpresa" type="text"
                                                                class="form-control"
                                                                :placeholder="Cliente.tpdId == 2 ? 'Nome Fantasia' : 'Nome'" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>E-mail</label>
                                                            <input v-model="Cliente.cliEmail" type="text"
                                                                class="form-control" placeholder="E-mail" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Cliente.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>Nome Responsável</label>
                                                            <input v-model="Cliente.cliResponsavel" type="text"
                                                                class="form-control" placeholder="Responsável" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Cliente.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>CPF Responsável</label>
                                                            <input v-model="Cliente.cliCampoExtra1" type="text"
                                                                v-mask="'###.###.###-##'" class="form-control"
                                                                placeholder="CPF Responsável" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 col-lg-5" v-if="Cliente.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>Razão Social</label>
                                                            <input v-model="Cliente.cliRazaoSocial" type="text"
                                                                class="form-control" placeholder="Razão Social" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Telefone</label>
                                                            <input v-model="Cliente.cliTelefone"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Whatsapp</label>
                                                            <input v-model="Cliente.cliWhatsapp"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Whatsapp" />
                                                        </div>
                                                    </div>

                                                    <div class="col-md-2 col-lg-2" v-if="Cliente.tpdId == 1">
                                                        <div class="form-group">
                                                            <label>Data Nascimento</label>
                                                            <input v-model="Cliente.cliDataNascimento" type="date"
                                                                class="form-control" placeholder="Data Nascimento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Cliente.tpdId == 1">
                                                        <div class="form-group">
                                                            <label>Nome do Pai</label>
                                                            <input v-model="Cliente.cliNomePai" type="text"
                                                                class="form-control" placeholder="Nome do Pai" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Cliente.tpdId == 1">
                                                        <div class="form-group">
                                                            <label>Nome da Mãe</label>
                                                            <input v-model="Cliente.cliNomeMae" type="text"
                                                                class="form-control" placeholder="Nome da Mãe" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="Cliente.tpdId == 1">
                                                        <div class="form-group">
                                                            <label>Estado Civil</label>
                                                            <select v-model="Cliente.cliEstadoCivil"
                                                                class="form-select form-control"
                                                                @change="ValidaEstado()">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="(optionTipo, index) in TiposEstadosCivis"
                                                                    :key="index" :value="optionTipo.value">{{
                                                                    optionTipo.value }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Cliente.tpdId == 1">
                                                        <div class="form-group">
                                                            <label>Renda Mensal Familiar</label>
                                                            <input v-model="Cliente.cliCampoExtra2" type="text"
                                                                class="form-control" placeholder="Renda Mensal" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label
                                                                style="margin-right: 10px;font-size: 14px;margin-top:40px;">Possui
                                                                Corresponsável</label>
                                                            <input type="checkbox" v-model="isCheckedCorresponsvel" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--endereço-->
                                    <v-window-item value="endereco">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Endereço para contrato garantia (Obrigatório)</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Endereco.cleId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Cliente</label>
                                                            <input v-model="Endereco.cliId" type="text"
                                                                class="form-control" placeholder="Id Cliente" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>CEP</label>
                                                            <input v-model="Endereco.cleCep" v-mask="'#####-###'"
                                                                type="text" class="form-control" placeholder="CEP" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group" style="padding-top: 35px;">
                                                            <button type="button" class="btn btn-info"
                                                                @click.prevent="Buscacep(Endereco.cleCep)"
                                                                style="color:#ffffff;">
                                                                Verificar CEP
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 col-lg-5" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Endereço</label>
                                                            <input v-model="Endereco.cleEndereco" type="text"
                                                                class="form-control" placeholder="Endereço" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Número</label>
                                                            <input v-model="Endereco.cleNumero" type="number"
                                                                class="form-control" placeholder="Endereço" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Complemento</label>
                                                            <input v-model="Endereco.cleComplemento" type="text"
                                                                class="form-control" placeholder="Complemento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Estado</label>
                                                            <input v-model="Endereco.cleEstado" type="text"
                                                                class="form-control" placeholder="Estado" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Cidade</label>
                                                            <input v-model="Endereco.cleCidade" type="text"
                                                                class="form-control" placeholder="Cidade" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Bairro</label>
                                                            <input v-model="Endereco.cleBairro" type="text"
                                                                class="form-control" placeholder="Bairro" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-10 col-lg-10" v-if="showend">
                                                        <div class="form-group">
                                                            <button v-if="Endereco.cleId != 0" type="button"
                                                                class="btn btn-success" style="color:#ffffff;"
                                                                @click="EnderecoPut()">
                                                                Alterar Endereço
                                                            </button>
                                                            <button v-else type="button" class="btn btn-success"
                                                                style="color:#ffffff;" @click="EnderecoAdd()">
                                                                Salvar endereço
                                                            </button>
                                                            <a href="#" @click="EnderecoCancel()"
                                                                class="btn btn-link">Cancelar Endereço</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--endereco-->
                                    <!--Conjuge-->
                                    <v-window-item value="conjuge">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Dados do Conjuge</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Cliente.cliId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome Conjuge</label>
                                                            <input v-model="Cliente.cliNomeConjuge" type="text"
                                                                class="form-control" placeholder="Nome" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>CPF Conjuge</label>
                                                            <input v-model="Cliente.cliCpfConjuge"
                                                                v-mask="'###.###.###-##'" type="text"
                                                                class="form-control" placeholder="CPF" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Telefone Conjuge</label>
                                                            <input v-model="Cliente.cliTelefoneConjuge"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Whatsapp Conjuge</label>
                                                            <input v-model="Cliente.cliWhatsappConjuge"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Whatsapp" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Email Conjuge</label>
                                                            <input v-model="Cliente.cliEmailConjuge" type="text"
                                                                class="form-control" placeholder="Email" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Data Nascimento</label>
                                                            <input v-model="Cliente.cliDataNascimentoConjuge"
                                                                type="date" class="form-control"
                                                                placeholder="Data Nascimento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Endereço completo: *(logradouro, número, bairro,
                                                                cidade, estado e cep)</label>
                                                            <ckeditor :editor="editor" @ready="onReady"
                                                                v-model="Cliente.cliTexto1" :config="$ckconfig">
                                                            </ckeditor>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-10 col-lg-10" v-if="showend">
                                                        <div class="form-group">
                                                            <button v-if="Cliente.cliId != 0" type="button"
                                                                class="btn btn-success" style="color:#ffffff;"
                                                                @click="Put()">
                                                                Alterar
                                                            </button>
                                                            <a href="#" @click="EditCancel()"
                                                                class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--Conjuge-->
                                    <!--Corresponsavel 1-->
                                    <v-window-item value="corresponsavel">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Dados do Corresponsável 1</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Cliente.cliId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome Corresponsável</label>
                                                            <input v-model="Cliente.cliNomeCorresponsavel" type="text"
                                                                class="form-control" placeholder="Nome" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>CPF Corresponsável</label>
                                                            <input v-model="Cliente.cliCpfCorresponsavel"
                                                                v-mask="'###.###.###-##'" type="text"
                                                                class="form-control" placeholder="CPF" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Telefone Corresponsável</label>
                                                            <input v-model="Cliente.cliTelefoneCorresponsavel"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Whatsapp Corresponsável</label>
                                                            <input v-model="Cliente.cliWhatsappCorresponsavel"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Whatsapp" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Email Corresponsável</label>
                                                            <input v-model="Cliente.cliEmailCorresponsavel" type="text"
                                                                class="form-control" placeholder="Email" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Data Nascimento</label>
                                                            <input v-model="Cliente.cliDataNascimentoCorresponsavel"
                                                                type="date" class="form-control"
                                                                placeholder="Data Nascimento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome do Pai</label>
                                                            <input v-model="Cliente.cliNomePaiCorresponsavel"
                                                                type="text" class="form-control"
                                                                placeholder="Nome do Pai" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome da Mãe</label>
                                                            <input v-model="Cliente.cliNomeMaeCorresponsavel"
                                                                type="text" class="form-control"
                                                                placeholder="Nome da Mãe" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Estado Civil</label>
                                                            <select v-model="Cliente.cliEstadoCivilCorresponsavel"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="(optionTipo, index) in TiposEstadosCivis"
                                                                    :key="index" :value="optionTipo.value">{{
                                                                    optionTipo.value }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Endereço completo: *(logradouro, número, bairro,
                                                                cidade, estado e cep)</label>
                                                            <ckeditor :editor="editor" @ready="onReady"
                                                                v-model="Cliente.cliTexto2" :config="$ckconfig">
                                                            </ckeditor>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-10 col-lg-10" v-if="showend">
                                                        <div class="form-group">
                                                            <button v-if="Cliente.cliId != 0" type="button"
                                                                class="btn btn-success" style="color:#ffffff;"
                                                                @click="Put()">
                                                                Alterar
                                                            </button>
                                                            <a href="#" @click="EditCancel()"
                                                                class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--Corresponsavel 1-->
                                    <!--Corresponsavel 2-->
                                    <v-window-item value="corresponsavel2">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Dados do Corresponsável 2</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Cliente.cliId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome Corresponsável</label>
                                                            <input v-model="Cliente.cliNomeCorresponsavel2" type="text"
                                                                class="form-control" placeholder="Nome" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>CPF Corresponsável</label>
                                                            <input v-model="Cliente.cliCpfCorresponsavel2"
                                                                v-mask="'###.###.###-##'" type="text"
                                                                class="form-control" placeholder="CPF" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Telefone Corresponsável</label>
                                                            <input v-model="Cliente.cliTelefoneCorresponsavel2"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Whatsapp Corresponsável</label>
                                                            <input v-model="Cliente.cliWhatsappCorresponsavel2"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Whatsapp" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Email Corresponsável</label>
                                                            <input v-model="Cliente.cliEmailCorresponsavel2" type="text"
                                                                class="form-control" placeholder="Email" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Data Nascimento</label>
                                                            <input v-model="Cliente.cliDataNascimentoCorresponsavel2"
                                                                type="date" class="form-control"
                                                                placeholder="Data Nascimento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome do Pai</label>
                                                            <input v-model="Cliente.cliNomePaiCorresponsavel2"
                                                                type="text" class="form-control"
                                                                placeholder="Nome do Pai" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome da Mãe</label>
                                                            <input v-model="Cliente.cliNomeMaeCorresponsavel2"
                                                                type="text" class="form-control"
                                                                placeholder="Nome da Mãe" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Estado Civil</label>
                                                            <select v-model="Cliente.cliEstadoCivilCorresponsavel2"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="(optionTipo, index) in TiposEstadosCivis"
                                                                    :key="index" :value="optionTipo.value">{{
                                                                    optionTipo.value }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Endereço completo: *(logradouro, número, bairro,
                                                                cidade, estado e cep)</label>
                                                            <ckeditor :editor="editor" @ready="onReady"
                                                                v-model="Cliente.cliTexto3" :config="$ckconfig">
                                                            </ckeditor>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-10 col-lg-10" v-if="showend">
                                                        <div class="form-group">
                                                            <button v-if="Cliente.cliId != 0" type="button"
                                                                class="btn btn-success" style="color:#ffffff;"
                                                                @click="Put()">
                                                                Alterar
                                                            </button>
                                                            <a href="#" @click="EditCancel()"
                                                                class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--Corresponsavel 2-->
                                    <!--Docs-->
                                    <v-window-item value="docs">
                                        <div style="padding-top: 20px;padding-bottom: 10px;padding-left: 20px;">
                                            Selecione os documento necessários</div>
                                        <v-form>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="12" md="3">
                                                            <label>Nome Documento</label>
                                                            <input v-model="Docs.cdsNomeDoc" type="text"
                                                                class="form-control" placeholder="Nome Documento" />
                                                        </v-col>
                                                        <v-col cols="12" md="5">
                                                            <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                                                PDF</label>
                                                            <v-file-input v-model="selectedFile"
                                                                label="Selecione o arquivo" variant="underlined"
                                                                prepend-icon="mdi-file"
                                                                accept="image/*,application/pdf"></v-file-input>
                                                        </v-col>
                                                        <v-col cols="12" md="3">
                                                            <button type="button" class="btn btn-info"
                                                                @click.prevent="EnviarDocumento()"
                                                                style="color:#ffffff;margin-top: 20px;">
                                                                Inserir
                                                            </button>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">
                                                                        Documento
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Cadastro
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Visualização
                                                                    </th>
                                                                    <th>
                                                                        Ações
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in ListaDocs" :key="item.cdsId">
                                                                    <td>{{ item.cdsNomeDoc }}</td>
                                                                    <td>{{ formattedDate(item.cdsDataCadastro) }}</td>
                                                                    <td style="text-align: center;">
                                                                        <v-btn v-if="item.cdsUrlDoc != ''" icon
                                                                            @click.prevent="VisualizarDocumento(item)"
                                                                            variant="text">
                                                                            <v-icon>mdi-file-eye</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Visualizar</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn icon v-if="User.tpeid != 3"
                                                                            @click.prevent="DeleteDocumento(item)"
                                                                            variant="text">
                                                                            <v-icon>mdi-delete-forever-outline</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Excluir</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </v-row>
                                                </v-container>
                                            </v-form>
                                    </v-window-item>
                                    <!--Docs-->
                                    <!--consultas-->
                                    <v-window-item value="consultas">
                                        <div style="padding-top: 20px;padding-bottom: 10px;padding-left: 20px;">
                                            Consultas de Crédito</div>
                                        <v-form>
                                            <v-container>
                                                <v-row v-show="false">
                                                    <v-col cols="12" md="8">
                                                        <label>Selecione a Pessoa</label>
                                                        <select v-model="PessoaSelected"
                                                            class="form-select form-control">
                                                            <option :value=null>Selecione</option>
                                                            <option v-for="optionTipo in ListPessoas"
                                                                :key="optionTipo.documento" :value="optionTipo">{{
                                                                    optionTipo.nome }}</option>
                                                        </select>
                                                    </v-col>
                                                    <v-col cols="12" md="4" v-if="PessoaSelected!= null">
                                                        <button type="button" class="btn btn-info"
                                                            @click.prevent="ConsultaSerasa(PessoaSelected.documento, PessoaSelected.tipo, PessoaSelected.pessoa, User.cusid, Cliente.cliId)"
                                                            style="color:#ffffff;margin-top: 20px;">
                                                            Consultar
                                                        </button>

                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-table>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">
                                                                    Nome
                                                                </th>
                                                                <th class="text-left">
                                                                    Tipo
                                                                </th>
                                                                <th class="text-left">
                                                                    Cadastro
                                                                </th>
                                                                <th class="text-left">
                                                                    Score
                                                                </th>
                                                                <th class="text-left">
                                                                    Visualizações
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="item in ListaConsultas" :key="item.ccsId">
                                                                <td>{{ item.cliNome }}</td>
                                                                <td>{{ item.cliTipo }}</td>
                                                                <td>{{ formattedDate(item.ccsDataConsulta) }}</td>
                                                                <td>{{ item.ccsScore }}</td>
                                                                <td>
                                                                    <button type="button" class="btn btn-info"
                                                                        @click="CarregaModalSerasa(item)"
                                                                        style="color:#ffffff;margin:5px;padding:10px;">
                                                                        Crédito
                                                                    </button>
                                                                    <button type="button" class="btn btn-info"
                                                                        @click="CarregaModalJus(item)"
                                                                        style="color:#ffffff;margin:5px;padding:10px;">
                                                                        Jurídica
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </v-table>
                                                </v-row>
                                            </v-container>
                                        </v-form>

                                    </v-window-item>
                                    <!--consultas-->
                                </v-window>
                            </div>
                        </div>
                    </div>
                    <div class="card-action" v-if="tab == 'dados'">
                        <button v-if="Cliente.cliId != 0" type="button" class="btn btn-success" style="color:#ffffff;"
                            @click="Put()" :disabled="isSubmittingPut">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()"
                            :disabled="isSubmittingAdd">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de Cliente</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body"
                                v-if="ListGarantidorasGeral != '' && ListImobiliariasGeral != '' && ListClientesGeral != '' && ListClientes != ''">
                                <v-row>
                                    <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                        <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <easy-data-table :headers="headers" :items="ListClientes" v-model="itemsSelected"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                                    <template #item-garId="item">
                                        <span> {{item.garId !== null ? ListGarantidorasGeral.filter(x => x.garId ==
                                            item.garId)[0].garNomeEmpresa : null }}</span>
                                    </template>
                                    <template #item-imoId="item">
                                        <span>{{ListImobiliariasGeral != '' ? ListImobiliariasGeral.filter(x => x.imoId
                                            === item.imoId)[0].imoNomeEmpresa : null }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                            <v-icon class="editiconcor">mdi-file-edit</v-icon>
                                            <v-tooltip activator="client" location="top">Editar</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="DeleteGrid(item)" variant="text"
                                            v-if="User != '' && User.garid == 0">
                                            <v-icon class="deliconcor">mdi-delete-forever</v-icon>
                                            <v-tooltip activator="client" location="top">Excluir</v-tooltip>
                                        </v-btn>
                                    </template>
                                </easy-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <v-row justify="center">
            <v-dialog v-model="dialogSerasa" class="controlcelEnd" transition="dialog-bottom-transition" width="auto">
                <v-card ref="serasaContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Análise de Crédito</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px"
                        v-if="ListaSerasa != '' && ListaSerasa != null && ListaSerasa.reports && ListaSerasa.reports.length > 0">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;">
                                        <v-row v-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PF_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.defaultRate }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.consumerName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.motherName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ formattedDate(ListaSerasa.reports[0].registration.birthDate)
                                                    }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            v-else-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PJ_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                                <span>{{ ListaSerasa.reports[0].score.message }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ (ListaSerasa.reports[0].score.defaultRate / 100) }} %</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.companyDocument }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.companyName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    formattedDate(ListaSerasa.reports[0].registration.foundationDate)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cidade: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.city }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Estado: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.state }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            v-else-if="ListaSerasa.reports[0].reportName == 'RELATORIO_AVANCADO_TOP_SCORE_PF_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.defaultRate }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.consumerName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.motherName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.maritalStatusDescription
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ formattedDate(ListaSerasa.reports[0].registration.birthDate)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Ocupação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.occupation
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.addressLine }} - {{
                                                    ListaSerasa.reports[0].registration.address.district }} - {{
                                                        ListaSerasa.reports[0].registration.address.city }}/{{
                                                        ListaSerasa.reports[0].registration.address.state }} - Cep: {{
                                                        ListaSerasa.reports[0].registration.address.zipCode }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].registration.phones && ListaSerasa.reports[0].registration.phones.length > 0">
                                                <span style="font-weight: 500;">Fone 1: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].registration.phones && ListaSerasa.reports[0].registration.phones.length > 0">
                                                <span>{{ ListaSerasa.reports[0].registration.phones[0].areaCode }}
                                                    {{ ListaSerasa.reports[0].registration.phones[0].phoneNumber }} -
                                                    {{ ListaSerasa.reports[0].registration.phones[0].phoneType }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].registration.phones && ListaSerasa.reports[0].registration.phones.length > 1">
                                                <span style="font-weight: 500;">Fone 2: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].registration.phones && ListaSerasa.reports[0].registration.phones.length > 1">
                                                <span>{{ ListaSerasa.reports[0].registration.phones[1].areaCode }}
                                                    {{ ListaSerasa.reports[0].registration.phones[1].phoneNumber }} -
                                                    {{ ListaSerasa.reports[0].registration.phones[1].phoneType }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                                <span>{{ ListaSerasa.reports[0].score.message }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ (ListaSerasa.reports[0].score.defaultRate / 100) }} %</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.documentNumber
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.companyName
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fantasia:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.companyAlias
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    formattedDate(ListaSerasa.reports[0].identificationReport.companyFoundation)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Funcionários: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.numberEmployees
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Tributação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.taxOption
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Atividade Econômica: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.economicActivity
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cnae: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.cnae
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].identificationReport">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].identificationReport">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.addresses }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].identificationReport.phone">
                                                <span style="font-weight: 500;">Fone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].identificationReport.phone">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.phone }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.pefin &&
                                            ListaSerasa.reports[0].negativeData.pefin.pefinResponse &&
                                            ListaSerasa.reports[0].negativeData.pefin.pefinResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras (PEFIN)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(pefin, index) in ListaSerasa.reports[0].negativeData.pefin.pefinResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(pefin.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(pefin.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras (PEFIN)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.refin != '' &&
                                            ListaSerasa.reports[0].negativeData.refin.refinResponse &&
                                            ListaSerasa.reports[0].negativeData.refin.refinResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Restrições Financeiras (REFIN)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(refin, index) in ListaSerasa.reports[0].negativeData.refin.refinResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(refin.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(refin.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Restrições Financeiras (REFIN)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.notary &&
                                            ListaSerasa.reports[0].negativeData.notary.notaryResponse &&
                                            ListaSerasa.reports[0].negativeData.notary.notaryResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(prot, index) in ListaSerasa.reports[0].negativeData.notary.notaryResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(prot.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(prot.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número do Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.officeNumber }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.officeName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.check &&
                                            ListaSerasa.reports[0].negativeData.check.checkResponse &&
                                            ListaSerasa.reports[0].negativeData.check.checkResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Cheques Sem Fundo (CCF)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(cheq, index) in ListaSerasa.reports[0].negativeData.check.checkResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(cheq.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do banco: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do banco: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número da agência: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankAgencyId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Quantidade de cheques: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.checkCount }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Cheques Sem Fundo (CCF)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].negativeData &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Dívidas Vencidas (Convem)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(convem.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Dívidas Vencidas (Convem)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].facts &&
                                            ListaSerasa.reports[0].facts.inquiry &&
                                            ListaSerasa.reports[0].facts.inquiry.inquiryResponse &&
                                            ListaSerasa.reports[0].facts.inquiry.inquiryResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.inquiry.inquiryResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Segmento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.segmentDescription }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Quantidade:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.daysQuantity }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                                {{ ListaSerasa.reports[0].facts ? 'Existe' : 'Não existe' }}
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].facts &&
                                                ListaSerasa.reports[0].facts.judgementFilings &&
                                                ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse &&
                                                ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Judiciais
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(convem.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.state }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Judiciais
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].facts &&
                                            ListaSerasa.reports[0].facts.bankrupts &&
                                            ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse &&
                                            ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyName }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].partner &&
                                            ListaSerasa.reports[0].partner.partnershipResponse &&
                                            ListaSerasa.reports[0].partner.partnershipResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Sociedades
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].partner.partnershipResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Participação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.participationPercentage }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyState }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Status: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyStatus }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Sociedades
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PJ_PME' &&
                                            ListaSerasa.reports[0].director &&
                                            ListaSerasa.reports[0].director.DirectorResponse &&
                                            ListaSerasa.reports[0].director.DirectorResponse.results.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Administradores
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(dire, index) in ListaSerasa.reports[0].director.DirectorResponse.results"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Tipo Documento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.documentType }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Documento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.documentId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.name }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cargo: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.role }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Possui restrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.hasNegative ? "Sim" : "Não" }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>

                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="exportPdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogSerasa = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!--modal JusBrasil-->
        <v-row justify="center">
            <v-dialog v-model="dialogJusBrasil" class="controlcelEnd" transition="dialog-bottom-transition"
                width="auto">
                <v-card ref="jusContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Informações Jurídicas</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px" v-if="ListaJusBrasil != '' && ListaJusBrasil != null">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;" v-if="ListaJusBrasil.processos &&
                                        ListaJusBrasil.processos.length > 0">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaJusBrasil.nome }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Tipo: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaJusBrasil.identificacao.tipo }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaJusBrasil.identificacao.valor }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Processos
                                            </v-col>
                                            <v-col cols="12" md="12" v-for="(proc, index) in ListaJusBrasil.processos"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Tipo Processo: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.tipo_processo }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data Atualização: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.data_ultima_atualizacao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.natureza }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-if="proc.partes.length > 0">
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Partes: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left; padding-bottom: 2px; padding-top: 3px;">
                                                        <div v-for="(parte, indexParte) in proc.partes"
                                                            :key="indexParte">
                                                            <span><strong>Nome:</strong> {{ parte.nome }}</span><br>
                                                            <span><strong>Papel:</strong> {{ parte.papel }}</span>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Assunto: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.assunto }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Ano Processo: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.ano_do_processo }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Tribunal: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.tribunal }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.UF }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Comarca: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.comarca }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Fórum: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.forum }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da causa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(proc.valor_causa) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Numero Processo: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.numero_processo }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Link: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.link }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Status: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.status }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col v-else>
                                        <v-col v-if="ListaJusBrasil.fault" cols="12" md="12"
                                            style="background-color: #cccccc;margin-top:30px;">
                                            {{ ListaJusBrasil.fault.faultstring }}
                                        </v-col>
                                        <v-col v-else cols="12" md="12"
                                            style="background-color: #cccccc;margin-top:30px;">
                                            Nada Consta
                                        </v-col>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="export2Pdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogJusBrasil = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>

</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import moment from 'moment'
import { cpf } from 'cpf-cnpj-validator'
import Loader from '../../components/PageLoader.vue'

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
    name: 'ClientesView',
    components: {
        EasyDataTable,
        moment,
        Loader
    },
    data: () => ({
        isLoading: false,
        EditView: false,
         User: {
            garid:0,
            tpeid:0,
            pesid:0,
            cusid:0
        },
        ListGarantidorasGeral: [],
        ListParceirosGeral: [],
        ListImobiliariasGeral: [],
        ListImobiliarias: [],
        editor: DecoupledEditor,
        tab: null,
        searchValue: '',
        itemsSelected: [],
        NomeTela: 'Clientes',
        InfoTela: 'Lista de Clientes',
        MostraGrid: true,
        headers: [],
        isSubmittingAdd: false,
        isSubmittingPut: false,
        //dados
        Cliente: {
            cliId: 0,
            cliVisivel: null,
            cliDataCadastro: null,
            cliNomeEmpresa: '',
            cliRazaoSocial: '',
            tpdId: null,
            cliDocumento: '',
            cliTelefone: '',
            cliWhatsapp: '',
            cliResponsavel: '',
            cliEmail: '',
            cliAtivo: null,
            cliDataAniversario: null,
            cliCampoExtra1: '',
            cliCampoExtra2: '',
            cliCampoExtra3: '',
            cliCampoExtra4: '',
            cliCampoExtra5: '',
            cliTexto1: '',
            cliTexto2: '',
            cliTexto3: '',
            cliData1: null,
            cliData2: null,
            garId: null,
            imoId: null,
            cliNomePai: '',
            cliNomeMae: '',
            cliNomeConjuge: '',
            cliCpfConjuge: '',
            cliTelefoneConjuge: '',
            cliWhatsappConjuge: '',
            cliEmailConjuge: '',
            cliNomeCorresponsavel: '',
            cliCpfCorresponsavel: '',
            cliTelefoneCorresponsavel: '',
            cliWhatsappCorresponsavel: '',
            cliEmailCorresponsavel: '',
            cliDataNascimento: '',
            cliDataNamentoConjuge: '',
            cliEstadoCivil: null,
            cliDataNascimentoCorresponsavel: '',
            cliEstadoCivilCorresponsavel: null,
            cliNomePaiCorresponsavel: '',
            cliNomeMaeCorresponsavel: '',
            cliNomeCorresponsavel2: '',
            cliCpfCorresponsavel2: '',
            cliTelefoneCorresponsavel2: '',
            cliWhatsappCorresponsavel2: '',
            cliEmailCorresponsavel2: '',
            cliDataNascimentoCorresponsavel2: '',
            cliEstadoCivilCorresponsavel2: null,
            cliNomePaiCorresponsavel2: '',
            cliNomeMaeCorresponsavel2: '',
        },
        ListClientes: [],
        ListClientesGeral: [],
        TiposDocumentos: [],
        TiposEstadosCivis: [{ value: 'Casado(a)' }, { value: 'Solteiro(a)' }, { value: 'Divorciado(a)' }, { value: 'União Estável' }, { value: 'Viúvo(a)' }],
        //dados
        //imagens
        selectedFile: null,
        //endereco
        Endereco: {
            cleId: 0,
            grtId: 0,
            cdtId: 0,
            cleEndereco: '',
            cleNumero: 0,
            cleComplemento: '',
            cleObsEndereco: '',
            cleCep: '',
            clePais: '',
            cleEstado: '',
            cleCidade: '',
            cleBairro: '',
            cleCodigoDistrito: '',
            cliId: null
        },
        ListaEnderecos: [],
        showend: false,
        Retornocep: null,
        //endereco
        //consultas
        Consultas: {
            ccsId: 0,
            grtId: 0,
            cdtId: 0,
            cliId: null,
            cliNome: '',
            cliTipo: '',
            ccsSerasa: '',
            ccsScore: '',
            ccsUser: '',
            ccsJusBrasil: '',
            ccsDataConsulta: ''
        },
        ListaConsultas: [],
        ListConsultasGeral: [],
        PessoaSelected: null,
        ListPessoas: [],
        score: 0,
        dialogSerasa: false,
        ListaSerasa: null,
        ListaJusBrasil: null,
        ListaInvoice: null,
        ListaProdutosImg: [],
        dialogJusBrasil: false,
        //consultas
        //docs
        Docs: {
            cdsId: 0,
            grtId: 0,
            cdtId: 0,
            cliId: null,
            cdsNomeDoc: '',
            cdsUrlDoc: '',
            cdsUser: '',
            cdsDataCadastro: ''
        },
        ListaDocs: [],
        selectedFile: '',
        showdocs: false,
        //docs
        isCheckedCorresponsvel: false,
        isCheckedConjuge: false,
    }),
    methods: {
        startLoading() {
            this.isLoading = true;
        },
        stopLoading() {
            this.isLoading = false;
        },
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/Clientes/upload`, formData);
            return uploadResult;
        },
         buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/Clientes/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
         isEmailValid(email) {
            if (!email) {
            return false;
            }
            // Se houver espaços antes ou depois, rejeita
            if (email !== email.trim()) {
            return false;
            }
            // Regex simples: texto + '@' + texto + '.' + texto
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        },
        NormalizaDocumentoPessoa(pessoa, campoDocumento) {
            if (!pessoa || pessoa.tpdId !== 2 || !pessoa[campoDocumento]) return;

            const documento = pessoa[campoDocumento].toUpperCase().replace(/[^A-Z0-9./-]/g, '');
            if (documento !== pessoa[campoDocumento]) {
                pessoa[campoDocumento] = documento;
            }
        },
        NormalizaDocumento(value) {
            return String(value || '').toUpperCase().replace(/[.\-/\s]/g, '');
        },
        ValidaDocumentoPessoa(pessoa, campoDocumento) {
            if (pessoa.tpdId === 1) {
                return this.ValidaCpf(pessoa[campoDocumento]);
            }

            if (pessoa.tpdId === 2) {
                return this.ValidaCnpjAlfanumerico(pessoa[campoDocumento]);
            }

            return false;
        },
        ValidaCpf(value) {
            const cpfNormalizado = this.NormalizaDocumento(value);
            return cpf.isValid(cpfNormalizado);
        },
        ValidaCnpjAlfanumerico(value) {
            const cnpjNormalizado = this.NormalizaDocumento(value);
            if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpjNormalizado) || /^([A-Z0-9])\1{13}$/.test(cnpjNormalizado)) return false;

            const primeiroDigito = this.CalculaDigitoCnpjAlfanumerico(cnpjNormalizado.substring(0, 12));
            const segundoDigito = this.CalculaDigitoCnpjAlfanumerico(cnpjNormalizado.substring(0, 12) + primeiroDigito);

            return cnpjNormalizado.substring(12) === primeiroDigito + segundoDigito;
        },
        CalculaDigitoCnpjAlfanumerico(base) {
            const pesos = base.length === 12
                ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
                : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

            const soma = base.split('').reduce((total, char, index) => {
                return total + (char.charCodeAt(0) - 48) * pesos[index];
            }, 0);
            const resto = soma % 11;

            return resto < 2 ? '0' : String(11 - resto);
        },
        CarregaLista() {
            this.ListClientes = this.ListClientesGeral;
        },
        //imagens
        //cliantidora
        //edit
        ValidaEstado() {
            //console.log('aquii')
            //console.log(this.Cliente.cliEstadoCivil)
            if (this.Cliente.cliEstadoCivil == 'Casado(a)' || this.Cliente.cliEstadoCivil == 'União Estável') {
                this.isCheckedConjuge = true;
            }
            else {
                this.isCheckedConjuge = false;
            }
        },
        EditNew() {
            this.EditView = true;
            this.Cliente.cliId = 0;
            this.Cliente.cliVisivel = null;
            this.Cliente.cliDataCadastro = null;
            this.Cliente.cliNomeEmpresa = '';
            this.Cliente.cliRazaoSocial = '';
            this.Cliente.tpdId = null;
            this.Cliente.cliDocumento = '';
            this.Cliente.cliTelefone = '';
            this.Cliente.cliWhatsapp = '';
            this.Cliente.cliResponsavel = '';
            this.Cliente.cliEmail = '';
            this.Cliente.cliAtivo = null;
            this.Cliente.cliDataAniversario = null;
            this.Cliente.cliCampoExtra1 = '';
            this.Cliente.cliCampoExtra2 = '';
            this.Cliente.cliCampoExtra3 = '';
            this.Cliente.cliCampoExtra4 = '';
            this.Cliente.cliCampoExtra5 = '';
            this.Cliente.cliTexto1 = '';
            this.Cliente.cliTexto2 = '';
            this.Cliente.cliTexto3 = '';
            this.Cliente.cliData1 = null;
            this.Cliente.cliData2 = null;
            this.Cliente.garId = this.User.garid == 0 ? null : this.User.garid;
            this.Cliente.imoId = this.User.tpeid == 1 ? null : this.User.tpeid == 3 ? this.User.pesid : null;
            this.Cliente.cliNomePai = '';
            this.Cliente.cliNomeMae = '';
            this.Cliente.cliNomeConjuge = '';
            this.Cliente.cliCpfConjuge = '';
            this.Cliente.cliTelefoneConjuge = '';
            this.Cliente.cliWhatsappConjuge = '';
            this.Cliente.cliEmailConjuge = '';
            this.Cliente.cliNomeCorresponsavel = '';
            this.Cliente.cliCpfCorresponsavel = '';
            this.Cliente.cliTelefoneCorresponsavel = '';
            this.Cliente.cliWhatsappCorresponsavel = '';
            this.Cliente.cliEmailCorresponsavel = '';
            this.Cliente.cliDataNascimento = '';
            this.Cliente.cliDataNamentoConjuge = '';
            this.Cliente.cliEstadoCivil = null;
            this.Cliente.cliDataNascimentoCorresponsavel = '';
            this.Cliente.cliEstadoCivilCorresponsavel = null;
            this.Cliente.cliNomePaiCorresponsavel = '';
            this.Cliente.cliNomeMaeCorresponsavel = '';
            this.Cliente.cliNomeCorresponsavel2 = '';
            this.Cliente.cliCpfCorresponsavel2 = '';
            this.Cliente.cliTelefoneCorresponsavel2 = '';
            this.Cliente.cliWhatsappCorresponsavel2 = '';
            this.Cliente.cliEmailCorresponsavel2 = '';
            this.Cliente.cliDataNascimentoCorresponsavel2 = '';
            this.Cliente.cliEstadoCivilCorresponsavel2 = null;
            this.Cliente.cliNomePaiCorresponsavel2 = '';
            this.Cliente.cliNomeMaeCorresponsavel2 = '';
            //endereco
            this.Endereco.cleId = 0;
            this.Endereco.grtId = 0;
            this.Endereco.cdtId = 0;
            this.Endereco.cleEndereco = '';
            this.Endereco.cleNumero = 0;
            this.Endereco.cleComplemento = '';
            this.Endereco.cleObsEndereco = '';
            this.Endereco.cleCep = '';
            this.Endereco.clePais = '';
            this.Endereco.cleEstado = '';
            this.Endereco.cleCidade = '';
            this.Endereco.cleBairro = '';
            this.showend = false;
            this.Retornocep = null;
            this.ListImobiliarias = [];
            if (this.User.garid != 0) {
                this.BuscaImobiliarias();
            }
            //this.ListImobiliariasGeral = [];
            //consultas
            this.Consultas.ccsId = 0;
            this.Consultas.grtId = 0;
            this.Consultas.cdtId = 0;
            this.Consultas.cliId = null;
            this.Consultas.cliNome = '';
            this.Consultas.cliTipo = '';
            this.Consultas.ccsSerasa = '';
            this.Consultas.ccsScore = '';
            this.Consultas.ccsUser = '';
            this.Consultas.ccsJusBrasil = '';
            this.Consultas.ccsDataConsulta = '';
            //consultas
            //docs
            this.Docs.cdsId = 0;
            this.Docs.grtId = 0;
            this.Docs.cdtId = 0;
            this.Docs.cliId = null;
            this.Docs.cdsNomeDoc = '';
            this.Docs.cdsUrlDoc = '';
            this.Docs.cdsUser = '';
            this.Docs.cdsDataCadastro = '';
            this.selectedFile = '';
            //docs
            this.tab = 'dados';
        },
        EditCancel() {
            //window.location.reload();
            this.$router.go(0);
        },
        EditGrid(item) {
            this.EditView = true;
            this.tab = 'dados';
            //console.log('item')
            // console.log(item)
            if (item.cliId != '') {
                // Lógica clia editar o item
                axios.get(`/Telas/Clientes/GetById/` + item.cliId)
                    .then(response => {
                        this.Cliente = response.data;
                        if (this.Cliente.cliData1) {
                            this.Cliente.cliData1 = moment(this.Cliente.cliData1).format("YYYY-MM-DD");
                        }
                        if (this.Cliente.cliDataNascimento) {
                            this.Cliente.cliDataNascimento = moment(this.Cliente.cliDataNascimento).format("YYYY-MM-DD");
                        }

                        if (this.Cliente.cliDataNascimentoConjuge) {
                            this.Cliente.cliDataNascimentoConjuge = moment(this.Cliente.cliDataNascimentoConjuge).format("YYYY-MM-DD");
                        }
                        //carrecli endereços
                        this.CarregaEndereco(item.cliId);

                        //carrega imobiliarias
                        this.BuscaImobiliarias();

                        if (this.Cliente.cliEstadoCivil == 'Casado(a)' || this.Cliente.cliEstadoCivil == 'União Estável') {
                            this.isCheckedConjuge = true;
                        }

                        if (this.Cliente.cliNomeCorresponsavel != null && this.Cliente.cliNomeCorresponsavel != '') {
                            this.isCheckedCorresponsvel = true;
                        }

                        if (this.Cliente.cliNomeCorresponsavel2 != null && this.Cliente.cliNomeCorresponsavel2 != '') {
                            this.isCheckedCorresponsvel = true;
                        }

                        if (this.Cliente.cliDataNascimentoCorresponsavel) {
                            this.Cliente.cliDataNascimentoCorresponsavel = moment(this.Cliente.cliDataNascimentoCorresponsavel).format("YYYY-MM-DD");
                        }

                        if (this.Cliente.cliDataNascimentoCorresponsavel2) {
                            this.Cliente.cliDataNascimentoCorresponsavel2 = moment(this.Cliente.cliDataNascimentoCorresponsavel2).format("YYYY-MM-DD");
                        }

                        //carrecli consultas
                        this.CarregaConsultas(item.cliId);
                        this.CarregaPessoas(this.Cliente);

                        //carrecli docs
                        this.CarregaDocs(item.cliId);

                    });


            }
        },
        async Add() {
            if (this.isSubmittingAdd) return; // Proteção adicional
            this.isSubmittingAdd = true;

            if (this.Cliente.garId === '' || this.Cliente.garId === null) {
                this.$mensagemAviso("Campo Garantidora Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.imoId == '' || this.Cliente.imoId == null) {
                this.$mensagemAviso("Campo Imobiliária Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.tpdId === '' || this.Cliente.tpdId === null) {
                this.$mensagemAviso("Campo Tipo Pessoa Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliDocumento === '' || this.Cliente.cliDocumento === null) {
                this.$mensagemAviso("Campo Nº Documento Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliDocumento != '' && this.Cliente.tpdId === 1 && !this.ValidaCpf(this.Cliente.cliDocumento)) {
                this.$mensagemAviso("Campo Nº Documento Inválido.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliDocumento != '' && this.Cliente.tpdId === 2 && !this.ValidaCnpjAlfanumerico(this.Cliente.cliDocumento)) {
                this.$mensagemAviso("Campo Nº Documento Inválido.")
                this.isSubmittingAdd = false;
            }
            else if (this.ListClientesGeral.filter(x => x.cliDocumento == this.Cliente.cliDocumento && x.garId == this.Cliente.garId && x.imoId == this.Cliente.imoId && x.cliId != this.Cliente.cliId).length > 0) {
                this.$mensagemAviso("Cliente ja cadastrado nesse Documento.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliNomeEmpresa == '' || this.Cliente.cliNomeEmpresa == null) {
                this.$mensagemAviso("Campo Nome Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliTelefone === '' || this.Cliente.cliTelefone === null) {
                this.$mensagemAviso("Campo Telefone Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliWhatsapp === '' || this.Cliente.cliWhatsapp === null) {
                this.$mensagemAviso("Campo Whatsapp Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliDataNascimento === '' || this.Cliente.cliDataNascimento === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Data Nascimento Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliEmail === '' || this.Cliente.cliEmail === null) {
                this.$mensagemAviso("Campo E-mail Obrigatório.")
                this.isSubmittingAdd = false;
            }
             else if (!this.isEmailValid(this.Cliente.cliEmail)) {
                this.$mensagemAviso("E-mail Inválido.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliResponsavel === '' || this.Cliente.cliResponsavel === null) && this.Cliente.tpdId === 2) {
                this.$mensagemAviso("Campo Responsável Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliCampoExtra1 === '' || this.Cliente.cliCampoExtra1 === null) && this.Cliente.tpdId === 2) {
                this.$mensagemAviso("Campo CPF Responsável Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliNomePai === '' || this.Cliente.cliNomePai === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Nome Pai Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliNomeMae === '' || this.Cliente.cliNomeMae === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Nome Mãe Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliEstadoCivil === '' || this.Cliente.cliEstadoCivil === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Estado Civil Obrigatório.")
                this.isSubmittingAdd = false;
            }
            /* else if ((this.Cliente.cliNomeConjuge === '' || this.Cliente.cliNomeConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliCpfConjuge === '' || this.Cliente.cliCpfConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliTelefoneConjuge === '' || this.Cliente.cliTelefoneConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliWhatsappConjuge === '' || this.Cliente.cliWhatsappConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliEmailConjuge === '' || this.Cliente.cliEmailConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliDataNascimentoConjuge === '' || this.Cliente.cliDataNascimentoConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliTexto1 === '' || this.Cliente.cliTexto1 === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliNomeCorresponsavel === '' || this.Cliente.cliNomeCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliCpfCorresponsavel === '' || this.Cliente.cliCpfCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliTelefoneCorresponsavel === '' || this.Cliente.cliTelefoneCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliWhatsappCorresponsavel === '' || this.Cliente.cliWhatsappCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliEmailCorresponsavel === '' || this.Cliente.cliEmailCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliDataNascimentoCorresponsavel === '' || this.Cliente.cliDataNascimentoCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliEstadoCivilCorresponsavel === '' || this.Cliente.cliEstadoCivilCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliNomeMaeCorresponsavel === '' || this.Cliente.cliNomeMaeCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliNomePaiCorresponsavel === '' || this.Cliente.cliNomePaiCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliTexto2 === '' || this.Cliente.cliTexto2 === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }*/
            else {
                if (this.Cliente.cliVisivel === "" || this.Cliente.cliVisivel === null) {
                    this.Cliente.cliVisivel = true;
                }
                if (this.Cliente.cliAtivo === "" || this.Cliente.cliAtivo === null) {
                    this.Cliente.cliAtivo = true;
                }
                if (this.Cliente.cliDataNascimento === "" || this.Cliente.cliDataNascimento === null) {
                    this.Cliente.cliDataNascimento = null;
                }
                if (this.Cliente.cliDataNascimentoCorresponsavel === "" || this.Cliente.cliDataNascimentoCorresponsavel === null) {
                    this.Cliente.cliDataNascimentoCorresponsavel = null;
                }
                if (this.Cliente.cliDataNascimentoCorresponsavel2 === "" || this.Cliente.cliDataNascimentoCorresponsavel2 === null) {
                    this.Cliente.cliDataNascimentoCorresponsavel2 = null;
                }
                if (this.Cliente.cliDataNascimentoConjuge === "" || this.Cliente.cliDataNascimentoConjuge === null) {
                    this.Cliente.cliDataNascimentoConjuge = null;
                }
                this.Cliente.cliDataCadastro = this.$moment().format('YYYY-MM-DD')
                axios.post(`/Telas/Clientes/Add`, this.Cliente)
                    .then(response => {
                        if (response.data > 0) {
                            this.Cliente.cliId = response.data;
                            this.CarregaEndereco(this.Cliente.cliId);
                            this.$mensagemAvisoSucesso("Registro Incluído. abas clia informações adicionais liberadas.")
                        }
                    }).finally(() => {
                        this.isSubmittingAdd = false; // Libera botão ao final
                    });

            }
        },
        Put() {
            if (this.isSubmittingPut) return; // Proteção adicional
            this.isSubmittingPut = true;

            // console.log(this.Cliente)
            if (this.Cliente.garId === '' || this.Cliente.garId === null) {
                this.$mensagemAviso("Campo Garantidora Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.imoId == '' || this.Cliente.imoId == null) {
                this.$mensagemAviso("Campo Imobiliária Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.tpdId === '' || this.Cliente.tpdId === null) {
                this.$mensagemAviso("Campo Tipo Pessoa Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliDocumento === '' || this.Cliente.cliDocumento === null) {
                this.$mensagemAviso("Campo Nº Documento Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliDocumento != '' && this.Cliente.tpdId === 1 && !this.ValidaCpf(this.Cliente.cliDocumento)) {
                this.$mensagemAviso("Campo Nº Documento Inválido.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliDocumento != '' && this.Cliente.tpdId === 2 && !this.ValidaCnpjAlfanumerico(this.Cliente.cliDocumento)) {
                this.$mensagemAviso("Campo Nº Documento Inválido.")
                this.isSubmittingPut = false;
            }
            else if (this.ListClientesGeral.filter(x => x.cliDocumento == this.Cliente.cliDocumento && x.garId == this.Cliente.garId && x.imoId == this.Cliente.imoId && x.cliId != this.Cliente.cliId).length > 0) {
                this.$mensagemAviso("Cliente ja cadastrado nesse Documento.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliNomeEmpresa == '' || this.Cliente.cliNomeEmpresa == null) {
                this.$mensagemAviso("Campo Nome Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliTelefone === '' || this.Cliente.cliTelefone === null) {
                this.$mensagemAviso("Campo Telefone Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliWhatsapp === '' || this.Cliente.cliWhatsapp === null) {
                this.$mensagemAviso("Campo Whatsapp Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliDataNascimento === '' || this.Cliente.cliDataNascimento === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Data Nascimento Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliEmail === '' || this.Cliente.cliEmail === null) {
                this.$mensagemAviso("Campo E-mail Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (!this.isEmailValid(this.Cliente.cliEmail)) {
                this.$mensagemAviso("E-mail Inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliResponsavel === '' || this.Cliente.cliResponsavel === null) && this.Cliente.tpdId === 2) {
                this.$mensagemAviso("Campo Responsável Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCampoExtra1 === '' || this.Cliente.cliCampoExtra1 === null) && this.Cliente.tpdId === 2) {
                this.$mensagemAviso("Campo CPF Responsável Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliNomePai === '' || this.Cliente.cliNomePai === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Nome Pai Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliNomeMae === '' || this.Cliente.cliNomeMae === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Nome Mãe Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEstadoCivil === '' || this.Cliente.cliEstadoCivil === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Estado Civil Obrigatório.")
            }
            else if ((this.Cliente.cliNomeConjuge === '' || this.Cliente.cliNomeConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCpfConjuge === '' || this.Cliente.cliCpfConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCpfConjuge != '' && this.Cliente.cliCpfConjuge != null) && this.isCheckedConjuge && !cpf.isValid(this.Cliente.cliCpfConjuge)) {
                this.$mensagemAviso("Documento Conjuge inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliTelefoneConjuge === '' || this.Cliente.cliTelefoneConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliWhatsappConjuge === '' || this.Cliente.cliWhatsappConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailConjuge === '' || this.Cliente.cliEmailConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliDataNascimentoConjuge === '' || this.Cliente.cliDataNascimentoConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliTexto1 === '' || this.Cliente.cliTexto1 === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliNomeCorresponsavel === '' || this.Cliente.cliNomeCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCpfCorresponsavel === '' || this.Cliente.cliCpfCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCpfCorresponsavel != '' && this.Cliente.cliCpfCorresponsavel != null) && this.isCheckedCorresponsvel && !cpf.isValid(this.Cliente.cliCpfCorresponsavel)) {
                this.$mensagemAviso("Documento Corresponsável inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliTelefoneCorresponsavel === '' || this.Cliente.cliTelefoneCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliWhatsappCorresponsavel === '' || this.Cliente.cliWhatsappCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailCorresponsavel === '' || this.Cliente.cliEmailCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if (!this.isEmailValid(this.Cliente.cliEmailCorresponsavel) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("E-mail Inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliDataNascimentoCorresponsavel === '' || this.Cliente.cliDataNascimentoCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEstadoCivilCorresponsavel === '' || this.Cliente.cliEstadoCivilCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliNomeMaeCorresponsavel === '' || this.Cliente.cliNomeMaeCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliNomePaiCorresponsavel === '' || this.Cliente.cliNomePaiCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliTexto2 === '' || this.Cliente.cliTexto2 === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCpfCorresponsavel2 != '' && this.Cliente.cliCpfCorresponsavel2 != null) && this.isCheckedCorresponsvel && !cpf.isValid(this.Cliente.cliCpfCorresponsavel2)) {
                this.$mensagemAviso("Documento Corresponsável 2 inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailCorresponsavel2 != '' && this.Cliente.cliEmailCorresponsavel2 != null) && this.isCheckedCorresponsvel && !this.isEmailValid(this.Cliente.cliEmailCorresponsavel2)) {
                this.$mensagemAviso("E-mail Corresponsável 2 inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailCorresponsavel != '' && this.Cliente.cliEmailCorresponsavel != null) && this.isCheckedCorresponsvel && this.Cliente.cliEmailCorresponsavel === this.Cliente.cliEmail){
                this.$mensagemAviso("E-mail Corresponsável não pode ser igual ao e-mail cliente.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailCorresponsavel2 != '' && this.Cliente.cliEmailCorresponsavel2 != null) && this.isCheckedCorresponsvel && this.Cliente.cliEmailCorresponsavel2 === this.Cliente.cliEmail){
                this.$mensagemAviso("E-mail Corresponsável 2 não pode ser igual ao e-mail cliente.")
                this.isSubmittingPut = false;
            }
           else if ((this.Cliente.cliEmailCorresponsavel2 != '' && this.Cliente.cliEmailCorresponsavel2 != null) && (this.Cliente.cliEmailCorresponsavel != '' && this.Cliente.cliEmailCorresponsavel != null) && this.isCheckedCorresponsvel && this.Cliente.cliEmailCorresponsavel2 === this.Cliente.cliEmailCorresponsavel){
                this.$mensagemAviso("E-mail Corresponsável 1 e 2 não podem ser iguais.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailConjuge != '' && this.Cliente.cliEmailConjuge != null) && this.isCheckedConjuge && this.Cliente.cliEmailConjuge === this.Cliente.cliEmail) {
                this.$mensagemAviso("Campo e-mail do Conjuge não pode ser igual ao e-mail cliente.")
                this.isSubmittingPut = false;
            }
            else {
                if (this.Cliente.cliVisivel === "" || this.Cliente.cliVisivel === null) {
                    this.Cliente.cliVisivel = true;
                }
                if (this.Cliente.cliAtivo === "" || this.Cliente.cliAtivo === null) {
                    this.Cliente.cliAtivo = true;
                }
                if (this.Cliente.cliDataNascimentoCorresponsavel2 === '') {
                    this.Cliente.cliDataNascimentoCorresponsavel2 = null;
                }


                if (!this.isCheckedCorresponsvel) {
                    this.Cliente.cliNomeCorresponsavel = '';
                    this.Cliente.cliCpfCorresponsavel = '';
                    this.Cliente.cliTelefoneCorresponsavel = '';
                    this.Cliente.cliWhatsappCorresponsavel = '';
                    this.Cliente.cliEmailCorresponsavel = '';
                    this.Cliente.cliDataNascimentoCorresponsavel = null;
                    this.Cliente.cliEstadoCivilCorresponsavel = null;
                    this.Cliente.cliNomePaiCorresponsavel = '';
                    this.Cliente.cliNomeMaeCorresponsavel = '';
                    this.Cliente.cliNomeCorresponsavel2 = '';
                    this.Cliente.cliCpfCorresponsavel2 = '';
                    this.Cliente.cliTelefoneCorresponsavel2 = '';
                    this.Cliente.cliWhatsappCorresponsavel2 = '';
                    this.Cliente.cliEmailCorresponsavel2 = '';
                    this.Cliente.cliDataNascimentoCorresponsavel2 = null;
                    this.Cliente.cliEstadoCivilCorresponsavel2 = null;
                    this.Cliente.cliNomePaiCorresponsavel2 = '';
                    this.Cliente.cliNomeMaeCorresponsavel2 = '';
                    this.Cliente.cliTexto2 = '';
                    this.Cliente.cliTexto3 = '';
                }


                //console.log('this.Cliente')
                //console.log(this.Cliente)

                axios.put(`/Telas/Clientes/Update`, this.Cliente)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    }).finally(() => {
                        this.isSubmittingPut = false; // Libera botão ao final
                    });
            }
        },
        //edit
        DeleteGrid(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica clia excluir o item
                        const cliam1 = item.cliId;
                        axios.delete(`/Telas/Clientes/Delete/${cliam1}`)
                            .then(response => {
                                if (response.status == 200) {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    this.Get();
                                }
                            });
                    }
                });
        },
        montaGrid() {
            this.headers = [];
            this.headers.push({ text: "Id", value: "cliId", sortable: true, });
            if (this.User.garid == 0) {
                this.headers.push({ text: "Garantidora", value: "garId", sortable: true, });
            }
            if (this.User.tpeid != 3) {
                this.headers.push({ text: "Imobiliaria", value: "imoId", sortable: true, });
            }
            this.headers.push({ text: "Nome", value: "cliNomeEmpresa", sortable: true, });
            this.headers.push({ text: "Documento", value: "cliDocumento", sortable: true, });
            this.headers.push({ text: "Whatsapp", value: "cliWhatsapp", sortable: true, });
            this.headers.push({ text: "Telefone", value: "cliTelefone", sortable: true, });
            this.headers.push({ text: "E-mail", value: "cliEmail", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        //cliantidora
        //endereco
        CarregaEndereco(_cliId) {
            axios.get(`/Telas/Clientes/GetEnderecoByCliClienteEndereco/` + _cliId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.Endereco = response.data[0];
                        this.showend = true;
                    }
                    else {
                        this.Endereco.cliId = _cliId;
                    }
                });
        },
        Buscacep(value) {
            if (value == "") {
                this.$mensagemAviso("Digite um CEP válido.")
            }
            else {
                fetch("https://viacep.com.br/ws/" + value + "/json/")
                    .then(response => {
                        if (!response.ok) {
                            throw new Error("CEP inexistente");
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.Retornocep = data;
                        if (this.Retornocep != null) {
                            this.Endereco.cleEndereco = this.Retornocep.logradouro;
                            this.Endereco.cleNumero = null;
                            this.Endereco.cleComplemento = null;
                            this.Endereco.cleEstado = this.Retornocep.uf;
                            this.Endereco.cleCidade = this.Retornocep.localidade;
                            this.Endereco.cleBairro = this.Retornocep.bairro;
                            this.Endereco.cleCodigoDistrito = this.Retornocep.ibge;
                            this.showend = true;
                        } else {
                            this.$mensagemAviso("CEP inexistente");
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        },
        EnderecoAdd() {
            if (this.Endereco.cleCep == '') {
                this.$mensagemAviso("Campo CEP Obrigatório.")
            }
            else if (this.Endereco.cleEndereco === '') {
                this.$mensagemAviso("Campo Endereço Obrigatório.")
            }
            else if (this.Endereco.cleNumero === '') {
                this.$mensagemAviso("Campo Número Obrigatório.")
            }
            else if (this.Endereco.cleEstado === '') {
                this.$mensagemAviso("Campo Estado Obrigatório.")
            }
            else if (this.Endereco.cleCidade === '') {
                this.$mensagemAviso("Campo Cidade Obrigatório.")
            }
            else if (this.Endereco.cleBairro === '') {
                this.$mensagemAviso("Campo Bairro Obrigatório.")
            }
            else {
                axios.post(`/Telas/Clientes/AddClienteEndereco`, this.Endereco)
                    .then(response => {
                        if (response.data > 0) {
                            this.Endereco.cleId = response.data;
                            this.$mensagemAvisoSucesso("Endereço Incluído")
                        }
                    });
            }
        },
        EnderecoPut() {
            if (this.Endereco.cleCep == '') {
                this.$mensagemAviso("Campo CEP Obrigatório.")
            }
            else if (this.Endereco.cleEndereco === '') {
                this.$mensagemAviso("Campo Endereço Obrigatório.")
            }
            else if (this.Endereco.cleNumero === '') {
                this.$mensagemAviso("Campo Número Obrigatório.")
            }
            else if (this.Endereco.cleEstado === '') {
                this.$mensagemAviso("Campo Estado Obrigatório.")
            }
            else if (this.Endereco.cleCidade === '') {
                this.$mensagemAviso("Campo Cidade Obrigatório.")
            }
            else if (this.Endereco.cleBairro === '') {
                this.$mensagemAviso("Campo Bairro Obrigatório.")
            }
            else {
                axios.put(`/Telas/Clientes/UpdateClienteEndereco`, this.Endereco)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Endereço Alterado.")
                        }
                    });
            }
        },
        EnderecoCancel() {
            /*this.Endereco.grtId = 0;
            this.Endereco.cdtId = 0;
            this.Endereco.gaeEndereco = '';
            this.Endereco.gaeNumero = null;
            this.Endereco.gaeComplemento = '';
            this.Endereco.gaeObsEndereco = '';
            this.Endereco.gaeCep = '';
            this.Endereco.gaePais = '';
            this.Endereco.gaeEstado = '';
            this.Endereco.gaeCidade = '';
            this.Endereco.gaeBairro = '';
            this.showend = false;*/
            this.$router.go(0);
        },
        //endereco
        //consultas
        CarregaConsultas(_cliId) {
            axios.get(`/Telas/Clientes/GetBycliIdClienteConsulta/` + _cliId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListaConsultas = response.data;
                    }
                    else {
                        this.ListaConsultas = [];
                    }
                });
        },
        CarregaPessoas(value) {
            this.ListPessoas = [];
            this.ListPessoas.push({ nome: value.cliNomeEmpresa + ' - ' + value.cliDocumento + ' - Cliente', documento: value.cliDocumento, tipo: value.tpdId, pessoa: 'Cliente' })

            if (value.cliNomeConjuge != null && value.cliNomeConjuge != '') {
                this.ListPessoas.push({ nome: value.cliNomeConjuge + ' - ' + value.cliCpfConjuge + ' - Conjuge', documento: value.cliCpfConjuge, tipo: value.tpdId, pessoa: 'Conjuge' })
            }

            if (value.cliNomeCorresponsavel != null && value.cliNomeCorresponsavel != '') {
                this.ListPessoas.push({ nome: value.cliNomeCorresponsavel + ' - ' + value.cliCpfCorresponsavel + ' - Corresponsável', documento: value.cliCpfCorresponsavel, tipo: value.tpdId, pessoa: 'Corresponsável' })
            }

            if (value.cliNomeCorresponsavel2 != null && value.cliNomeCorresponsavel2 != '') {
                this.ListPessoas.push({ nome: value.cliNomeCorresponsavel2 + ' - ' + value.cliCpfCorresponsavel2 + ' - Corresponsável 2', documento: value.cliCpfCorresponsavel2, tipo: value.tpdId, pessoa: 'Corresponsável 2' })
            }

        },
        async ConsultaSerasa(_doc, _tpdId, _pessoa, _cusId, _cliId) {
            if (this.PessoaSelected == '' || this.PessoaSelected == null) {
                 this.$mensagemAviso("Selecione Pessoa.")
            }
            else if (_doc == '' || _doc == null){
                this.$mensagemAviso("Documento não cadastrado.")
            }
            else {
                this.startLoading();
                let documentId = "";
                let tipo = "";
                let relatorio = "";
                let estado = this.Endereco.cleEstado;

                if (_tpdId == 1) {
                    tipo = 3;
                    relatorio = "RELATORIO_AVANCADO_TOP_SCORE_PF_PME"; //"RELATORIO_BASICO_PF_PME";
                    documentId = _doc.replaceAll('.', '').replaceAll('-', '');
                } else {
                    tipo = 4;
                    relatorio = "RELATORIO_AVANCADO_PJ_PME"; //"RELATORIO_BASICO_PJ_PME";
                    documentId = _doc.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '');
                }

                const serasaResponse = await axios.post(`/Telas/Clientes/checkOnlySerasa/` + documentId + '/' + tipo + '/' + relatorio + '/' + estado + '/' + _pessoa + '/' + _cusId + '/' + _cliId);

                if (serasaResponse.data != null && serasaResponse.data != ''){
                    if (serasaResponse.data > 0) {
                        const JusResponse = await axios.post(`/Telas/Clientes/checkOnlyJusBrasil/` + documentId + '/' + serasaResponse.data);
                    }

                    await this.CarregaConsultas(_cliId);
                    this.$mensagemAvisoSucesso("Consulta Efetuada com Sucesso.")
                }
                else{
                    this.$mensagemAviso("Não foi possível executar consulta, verifique o documento.")
                }
                this.stopLoading();
            }
        },
        CarregaModalSerasa(value) {
            this.ListaSerasa = JSON.parse(value.ccsSerasa);
            this.dialogSerasa = !this.dialogSerasa;
        },
        CarregaModalJus(value) {
            const cleanedJson = value.ccsJusBrasil
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');

            const parsedData = JSON.parse(cleanedJson);
            this.ListaJusBrasil = parsedData;
            this.dialogJusBrasil = !this.dialogJusBrasil;
        },
        async exportPdf() {
            console.log('🖨️ exportPdf iniciado')
            // 1) Aguarda o Vue terminar de renderizar
            await this.$nextTick()

            // 2) Busca o ref
            let element = this.$refs.serasaContent

            // Se for um componente Vue, pega o elemento real
            if (element && element.$el) {
                element = element.$el
                console.log('🔍 usando element.$el =', element)
            }

            // Verifica se está no documento
            if (!element || !document.body.contains(element)) {
                console.error('❌ Elemento não encontrado ou não anexado ao DOM')
                return
            }

            // 3) Faz o clone off-screen
            const clone = element.cloneNode(true)
            Object.assign(clone.style, {
                position: 'absolute',
                top: '-9999px',
                left: '-9999px',
                width: `${element.offsetWidth}px`,
                maxHeight: 'none',
                overflow: 'visible'
            })
            document.body.appendChild(clone)
            console.log('📋 clone adicionado ao body:', clone)

            try {
                // 4) Renderiza o clone
                console.log('⏳ chamando html2canvas em clone…')
                const canvas = await html2canvas(clone, { scale: 2, useCORS: true })
                console.log('✅ canvas gerado')

                // 5) Remove o clone
                document.body.removeChild(clone)
                console.log('🧹 clone removido')

                // 6) Gera o PDF
                const imgData = canvas.toDataURL('image/png')
                const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })

                const margin = 10;
                const pageW = pdf.internal.pageSize.getWidth()
                const pageH = pdf.internal.pageSize.getHeight()
                const props = pdf.getImageProperties(imgData)
                const imgW = pageW
                const imgH = (props.height * pageW) / props.width

                let posY = margin;
                pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)

                while (imgH - Math.abs(posY) > pageH) {
                    posY -= pageH
                    pdf.addPage()
                    pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)
                }

                pdf.save('analise_credito.pdf')
                console.log('✅ PDF salvo')
            }
            catch (err) {
                console.error('❌ erro ao gerar PDF:', err)
                // garante remoção do clone
                if (document.body.contains(clone)) {
                    document.body.removeChild(clone)
                }
            }
        },
        async export2Pdf() {
            console.log('🖨️ exportPdf iniciado')
            // 1) Aguarda o Vue terminar de renderizar
            await this.$nextTick()

            // 2) Busca o ref
            let element = this.$refs.jusContent

            // Se for um componente Vue, pega o elemento real
            if (element && element.$el) {
                element = element.$el
                console.log('🔍 usando element.$el =', element)
            }

            // Verifica se está no documento
            if (!element || !document.body.contains(element)) {
                console.error('❌ Elemento não encontrado ou não anexado ao DOM')
                return
            }

            // 3) Faz o clone off-screen
            const clone = element.cloneNode(true)
            Object.assign(clone.style, {
                position: 'absolute',
                top: '-9999px',
                left: '-9999px',
                width: `${element.offsetWidth}px`,
                maxHeight: 'none',
                overflow: 'visible'
            })
            document.body.appendChild(clone)
            console.log('📋 clone adicionado ao body:', clone)

            try {
                // 4) Renderiza o clone
                console.log('⏳ chamando html2canvas em clone…')
                const canvas = await html2canvas(clone, { scale: 2, useCORS: true })
                console.log('✅ canvas gerado')

                // 5) Remove o clone
                document.body.removeChild(clone)
                console.log('🧹 clone removido')

                // 6) Gera o PDF
                const imgData = canvas.toDataURL('image/png')
                const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })

                const margin = 10;
                const pageW = pdf.internal.pageSize.getWidth()
                const pageH = pdf.internal.pageSize.getHeight()
                const props = pdf.getImageProperties(imgData)
                const imgW = pageW
                const imgH = (props.height * pageW) / props.width

                let posY = margin;
                pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)

                while (imgH - Math.abs(posY) > pageH) {
                    posY -= pageH
                    pdf.addPage()
                    pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)
                }

                pdf.save('analise_juridica.pdf')
                console.log('✅ PDF salvo')
            }
            catch (err) {
                console.error('❌ erro ao gerar PDF:', err)
                // garante remoção do clone
                if (document.body.contains(clone)) {
                    document.body.removeChild(clone)
                }
            }
        },
        //consultas
        //docs
        CarregaDocs(_cliId) {
            axios.get(`/Telas/Clientes/GetBycliIdClientesDocs/` + _cliId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListaDocs = response.data;
                    }
                    else {
                        this.ListaDocs = [];
                    }
                });
        },
        async EnviarDocumento() {
            if (this.Docs.cdsNomeDoc == '' || this.Docs.cdsNomeDoc == null) {
                this.$mensagemAviso("Digite nome do Documento a ser enviado.")
            }
            else if (this.selectedFile == '' || this.selectedFile == null) {
                this.$mensagemAviso("Selecione um Documento a ser enviado.")
            }
            else {
                if (this.selectedFile != '' && this.selectedFile != null) {
                    const uploadSuccess = await this.UploadImg(this.selectedFile[0]);
                    if (uploadSuccess.status == 200) {
                        let _docs = {
                            cdsId: 0,
                            grtId: 0,
                            cdtId: 0,
                            cliId: this.Cliente.cliId,
                            cdsNomeDoc: this.Docs.cdsNomeDoc,
                            cdsUrlDoc: uploadSuccess.data.nameFile,
                            cdsUser: this.User.cusid,
                            cdsDataCadastro: moment().format("YYYY-MM-DD")
                        };

                        await axios.post(`/Telas/Clientes/AddClientesDocs`, _docs)
                            .then((response) => {
                                if (response.data > 0) {
                                    this.CarregaDocs(this.Cliente.cliId);
                                    this.selectedFile = '';
                                    this.Docs.cdsNomeDoc = '';
                                }
                            });
                    }
                    else {
                        this.$mensagemErro("Não foi possível carregar imagem.")
                    }
                }
            }
        },
        DeleteDocumento(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para excluir o item
                        const param1 = item.cdsId;
                        axios.delete(`/Telas/Clientes/DeleteClientesDocs/${param1}`)
                            .then(response => {
                                if (response.status == 200) {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    this.CarregaDocs(this.Cliente.cliId);
                                }
                            });
                    }
                });
        },
        VisualizarDocumento(item) {
            if (item && item.cdsUrlDoc) {
                // Abre o PDF em uma nova aba
               this.openInNewTab(item.cdsUrlDoc);
            } else {
                console.error("URL não está disponível.");
            }
        },
        //docs
        BuscaImobiliarias() {
            axios.get(`/Telas/Clientes/GetByGarIdParIdImobilairias/` + this.Cliente.garId + '/0')
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListImobiliariasGeral = response.data;
                        this.ListImobiliarias = this.ListImobiliariasGeral;
                    }
                });
        },
        async Get() {
            await axios.get(`/Telas/Clientes/GetDados`)
               .then(response => {
               this.ListGarantidorasGeral = response.data.garantidoras.filter(x => x.garAtivo);
                this.ListImobiliariasGeral = response.data.imobiliarias.filter(x => x.imoAtivo);
                 this.EditView = false;
                this.ListClientesGeral = response.data.clientes.filter(x => x.cliAtivo);
                this.CarregaLista();
                this.montaGrid();
                this.TiposDocumentos = response.data.tipoDocumentos.filter(x => x.tpdAtivo);
                this.User.tpeid = response.data.tpeId
                this.User.garid = response.data.garId
                this.User.pesid = response.data.pesId
                this.User.cusid = response.data.cusId;
         });
        }
    },
    created() {
        this.Get();
    },
    computed: {
        documentoMask() {
            return this.Cliente.tpdId === 1 ? '###.###.###-##' : 'XX.XXX.XXX/XXXX-##';
        }
    }
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}
</style>
